import { FC } from "react";
import { OrderDetailsHistoryEntryChangeApprovalStatusEvent } from "../../../common/types/order-details-history-entry-event";
import orderDetailsHistoryEntryChangeApprovalStatusContentHelper from "./order-details-history-entry-change-approval-status-content.helper";

type OrderDetailsHistoryEntryChangeApprovalStatusContentComponentProps = {
  event: OrderDetailsHistoryEntryChangeApprovalStatusEvent;
};

const OrderDetailsHistoryEntryChangeApprovalStatusContentComponent: FC<
  OrderDetailsHistoryEntryChangeApprovalStatusContentComponentProps
> = (props) => {
  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {orderDetailsHistoryEntryChangeApprovalStatusContentHelper.getHeadingText(
          props.event.approvalStatus,
        )}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryChangeApprovalStatusContentComponent;
